import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

class Icon extends React.Component {
    getVariations() {
        const variations = {
            'icon--highlight': this.props.highlight,
            'icon--left': this.props.left,
            'icon--offset-left': this.props.offsetLeft,
            'icon--offset-right': this.props.offsetRight
        };

        variations[`icon--${this.props.size}`] = this.props.size;

        return variations;
    }

    render() {
        let classes = classNames(
            'icon',
            `icon--${this.props.icon}`,
            this.getVariations(),
            this.props.className
        );
        return (
            <span className={classes} />
        );
    }
}

Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['large', '2x', '3x', '4x', '5x'])
};

export default Icon;



// WEBPACK FOOTER //
// ./js/launch/components/Icon.jsx